import './fullscreen-container.css';

import { Divider } from 'primereact/divider';
import React from 'react';
import { Outlet } from 'react-router-dom';

export const FullscreenContainer = () => {
  return (
    <>
      <header>
        <div
          className="flex justify-content-center align-items-center"
          style={{ textAlign: 'center', height: 82 }}
        >
          <h1 className="m-0">MINDY</h1>
        </div>
        <Divider className="mt-0" />
      </header>
      <div className="card-container">
        <Outlet />
      </div>
    </>
  );
};
